/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ValidationError } from './validationError';

export interface HTTPValidationError {
  detail?: ValidationError[];
}
